import React, { useEffect, useRef, useState } from 'react';
import './collaborators-org.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { getCollectionFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { properCase } from '@/utils/properCase';
import AddCollaboratorModal from './add-collaborator-modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPlusCircle, faXmarkSquare } from '@fortawesome/free-solid-svg-icons';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { getEmailContent } from '@/utils/getEmailContent';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';

const CollaboratorsOrg = ({ 
    gameData,
    orgs,
    formData,
    saveData,
    changeCollabSystem,
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ selectedOrg, setSelectedOrg ] = useState(null);
    const [ orgMembers, setOrgMembers ] = useState(null);
    const [ gameRegs, setGameRegs ] = useState(null);
    const [ collabs, setCollabs ] = useState([]);
    const [ showAddCollabModal, setShowAddCollabModal ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ isDirty, setIsDirty ] = useState(false);
    const [ newOrg, setNewOrg ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const approveRef = useRef();
    const membersRef = useRef();
    const regsRef = useRef();
    const newCollabRef = useRef();
    let membersListener;
    let regsListener;
    const navigate = useNavigate();
    const storage = getStorage();

    useEffect(() => {

        return () => {
            if (membersListener) membersListener();
        }
    }, [])

    useEffect(() => {
        if (!selectedOrg) return;
        console.log('selected org changed: ' + selectedOrg);
        if (selectedOrg) {
            getOrgData();
        }
    }, [selectedOrg])

    useEffect(() => {
        if (!formData) return;
        if (formData.gameId) {
            getGameRegs();
        }
        if (formData.orgId) {
            setSelectedOrg(formData.orgId);
        }
    }, [formData])

    useEffect(() => {
        console.log(isDirty);
    }, [isDirty])

    useEffect(() => {
        console.log(orgMembers);
        console.log(gameRegs);
        if (!orgMembers || !gameRegs) return;
        let collabArr = []
        
        for (let appId of Object.keys(gameRegs.roles)) {
            if (!orgMembers[appId]) continue;
            if (
                gameRegs.roles[appId].length === 1 && 
                gameRegs.roles[appId][0] === 'player'
            ) continue;
            const member = orgMembers[appId];
            let tempRoles = [...gameRegs.roles[appId]];
            if (tempRoles.includes('player')) {
                tempRoles.splice(tempRoles.indexOf('player'), 1);    
            }
            const role = tempRoles[0];
            const order = 
                role === 'owner' ? 0 :
                role === 'manager' ? 1 : 2;
            const obj = {
                'fName': member.fName,
                'lName': member.lName,
                'icon': member.icon,
                'gradient': member.gradient,
                'appId': appId,
                'role': role,
                'order': order
            }
            collabArr.push(obj);
        }
        setCollabs(sortPlayers({
            'playerList': collabArr
        }));
        console.log(gameRegs);
    }, [orgMembers, gameRegs])

    function saveOrgChange(orgId) {
        setSelectedOrg(orgId);
        // removeOrgConnection(orgId);
    }

    async function getOrgData() {
        console.log(selectedOrg);
        saveData('orgId', selectedOrg);
        const res = await UseCloudFunction(
            'getOrgData', 
            {
                'orgId': selectedOrg,
                'appId': userProfile.appId,
                'noInvites': true
            }
        );
        console.log(res);
        if (res.error) {
            setAlertMessage(`Sorry, something went wrong. Try again later. (Error: ${res.error})`);
            return;
        }
        setOrgMembers(res.members);
        
        // getCollectionFromDb({
        //     'collection': 'orgMemberDocs',
        //     'param1': {
        //         'key': 'orgId',
        //         'value': selectedOrg,
        //         'condition': '=='
        //     },
        //     'callback': callback,
        //     'handleListener': handleListener
        // })
        // function callback(data) {
        //     membersRef.current = {...membersRef.current, ...data.members};
        //     setOrgMembers(membersRef.current);
        // }
        // function handleListener(unsub) {
        //     membersListener = unsub;
        // }
    }

    function getGameRegs() {
        console.log('getting game regs: ' + formData.gameId)
        getUniqueDocumentFromDb({
            'collection': `games/${formData.gameId}/registrations`,
            'docId': `${formData.gameId}-regs`,
            'callback': callback,
            'handleListener': handleListener 
        })
        function callback(data) {
            regsRef.current = {...data};
            setGameRegs(regsRef.current);
        }
        function handleListener(unsub) {
            regsListener = unsub;
        }
    }

    function removeOrgConnection() {
        if (gameData.orgId) {
            setConfirmMessage('Are you sure you want to change the Organization from which you can '+
                'add collaborators? Games can only be shared within one organization.<br /><br />'+
                '<b>Warning</b>: This will remove from the game any existing collaborators from your former' +
                ' organization. This action cannot be undone and will take place when you click "OK".')
            approveRef.current = () => {
                continueRemoveOrgConnection();                
            }
        } else {
            removeOrgConnectionFromClient();
        }

        async function continueRemoveOrgConnection() {
            const res = await UseCloudFunction(
                'removeGameOrgConnection',
                {
                    'appId': userProfile.appId,
                    'gameId': formData.gameId,
                    'orgId': gameData.orgId,   
                }
            )
            console.log(res);
            if (res.error) {
                setAlertMessage(`Sorry, something went wrong. Please try again later. (Error: ${res.error})`);
                return;
            }
        }
    }

    function removeOrgConnectionFromClient() {
        let tempRegs = {...gameRegs};
        let owner;
        let tempRoles = {...tempRegs.roles};
        for (let appId of Object.keys(tempRoles)) {
            if (tempRegs.roles[appId].includes('owner')) {
                owner = appId;
                continue; 
            }
            if (tempRegs.roles[appId].includes('player')) {
                continue;
            }
            delete tempRoles[appId];
        }
        if (!owner) {
            setAlertMessage('Sorry, something went wrong. Try again later.');
            return;
        }
        tempRegs.list = [owner];
        tempRegs.roles = {...tempRoles}
        // if (orgId) {
        //     setSelectedOrg(orgId);
        // }
        regsRef.current = {...tempRegs};
        setGameRegs(regsRef.current);
        saveData('orgId', null);
        setSelectedOrg(null);
    }

    function addCollaborator(appId, role) {
        let tempRegs = {...regsRef.current};
        if (
            tempRegs.roles[appId] && 
            !tempRegs.roles[appId].includes(role)
        ) {
            tempRegs.roles[appId].push(role);
        } else if (!tempRegs.roles[appId]) {
            tempRegs.roles[appId] = [role];
        }
        if (!tempRegs.list.includes(appId)) {
            tempRegs.list.push(appId);
        }
        regsRef.current = {...tempRegs};
        setGameRegs(regsRef.current);
        newCollabRef.current = {
            ...newCollabRef.current,
            ...{[appId]: {'appId': appId, 'role': role}}
        };
        console.log(regsRef.current);
        setIsDirty(true);
    }

    function removeCollaborator(appId) {
        let tempRegs = {...regsRef.current};
        let roles = {...tempRegs.roles};
        let list = [...tempRegs.list];
        if (roles[appId].includes('player')) {
            roles[appId] = ['player'];
        } else {
            delete roles[appId];
            list.splice(list.indexOf(appId), 1);
        }
        tempRegs.list = list;
        tempRegs.roles = roles;
        regsRef.current = {...tempRegs};
        setGameRegs(regsRef.current);
        if (newCollabRef.current?.[appId]) {
            delete newCollabRef.current[appId];
        }
        setIsDirty(true);
    }

    async function saveCollabSettings() {
        setLoading(true);
        let tempGameData = {...gameData};
        let iconUrl = null;
        if (
            tempGameData.icon && 
            typeof tempGameData.icon === 'string' && 
            tempGameData.icon.includes('storage:')
        ) {
            const path = tempGameData.icon.split('storage:')[1];
            const imageRef = ref(storage, path);
            const url = await getDownloadURL(imageRef);
            iconUrl = url;
        } else if (tempGameData.icon && tempGameData.icon.includes('http')) {
            iconUrl = tempGameData.icon;
        } else {
            iconUrl = `https://app.gamably.com${tempGameData.icon}`;
        }
        tempGameData.orgId = selectedOrg;
        tempGameData.ts = new Date().getTime();
        let tempCollabData = {...regsRef.current};
        console.log(orgMembers);
        console.log(tempCollabData);
        console.log(formData);
        console.log(newCollabRef.current);

        const emailContentArr = [];
        if (Object.keys(newCollabRef.current).length > 0) {
            for (let appId of Object.keys(newCollabRef.current)) {
                const orgMemberData = orgMembers[appId];
                if (!orgMemberData) {
                    setAlertMessage(`Sorry, something went wrong. Please try again later. (Error: missing org member data)`);
                    return;
                };
                const emailContent = getEmailContent(
                    'gameManagerInvite',
                    {
                        'email': orgMemberData.email,
                        'appId': appId,
                        'gameName': tempGameData.gameName,
                        'userName': `${orgMemberData.fName} ${orgMemberData.lName}`,
                        'gameIcon': iconUrl,
                        'role': newCollabRef.current[appId].role,
                        'managerName': `${userProfile.fName} ${userProfile.lName}`,
                    }
                );
                emailContentArr.push(emailContent);
            }
        }

        const res = await UseCloudFunction(
            'saveGame', 
            {
                'gameObj': tempGameData, 
                'profile': userProfile, 
                'action': 'save collabs',
                'collabData': tempCollabData,
                'emailContentArr': emailContentArr,
            }
        )
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again later. (Error:${res.error})`);
            setLoading(false);
            return;
        }
        setAlertMessage('Settings saved successfully!')
        setLoading(false);
        setIsDirty(false);
        newCollabRef.current = {};
    }

    return (
        <div className='collaborators-org'>
            {
                (formData && orgs) &&
                <div className='collab-card'>
                    <div className='header-with-button'>
                        <h3>Invite Organization Members</h3>
                        {
                            (gameData.orgId) 
                            ?
                            <button 
                                className='g-button small-btn'
                                onClick={() => removeOrgConnection()}>
                                Remove Org Connection
                                <FontAwesomeIcon icon={faBan} />
                            </button>
                            :
                            <button
                                className='g-button small-btn'
                                onClick={() => changeCollabSystem('premium')}>
                                Invite a Premium Member Instead
                            </button>
                        }
                    </div>
                    <div className="g-space-1"></div>
                    <div className='g-list-item grey-background'>
                        <div className="g-space-1"></div>
                        {
                            (formData.orgId && orgs[formData.orgId])
                            ?
                            <div className='org-box field'>
                                <label>Chosen Organization</label>
                                <div className='g-list-item'>
                                    <div className='card-title'>
                                        <ImageContainer 
                                            src={orgs[formData.orgId].icon ?? '/images/icons/placeholder-icon-org.jpg'}
                                            className='head-icon' />
                                        {orgs[formData.orgId].name}
                                    </div>
                                    <div className='change'>
                                        <button 
                                            className='g-button text-only' 
                                            onClick={() => removeOrgConnection()} >
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='field small'>
                                <label>Choose an Organization</label>
                                <select 
                                    className='med-input'
                                    value={formData.orgId ?? ''} 
                                    onChange={(e) => saveOrgChange(e.target.value)}>
                                    <option value=''>Choose...</option>
                                    {
                                        (orgs && Object.values(orgs).length > 0) &&
                                        Object.values(orgs)
                                        .sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                                        .map(org => (
                                            <option 
                                                key={org.orgId} 
                                                value={org.orgId}>
                                                {org.name}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        }
                        <div className='g-space-1'></div>
                        {
                            (formData.orgId) &&
                            <div className='field'>
                                <label>Collaborators</label>
                                <div className='g-list-item collab-list-div'>
                                    <div className="g-space-0-5"></div>
                                    <button 
                                        className='g-button med-btn'
                                        onClick={() => setShowAddCollabModal(true)} >
                                        Add Collaborator
                                        <FontAwesomeIcon icon={faPlusCircle} className='icon' />
                                    </button>
                                    <div className="g-space-1"></div>
                                    <div className='collab-list'>
                                    {
                                        (collabs.length > 0)
                                        ?
                                        collabs.sort((a,b) => a.order > b.order ? 1 : -1)
                                        .map(c => (
                                            <div
                                                key={c.appId} 
                                                className='collab-list-item'>
                                                <div>{c.lName}, {c.fName}</div>
                                                <div className='buttons'>
                                                    <div>{properCase(c.role)}</div>
                                                    <button 
                                                        className={`g-button med-btn ${
                                                            c.role === 'owner' ? 'disabled' : ''
                                                        }`}
                                                        onClick={() => removeCollaborator(c.appId)}>
                                                        <FontAwesomeIcon icon={faXmarkSquare} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div>No collaborators yet...</div>
                                    }
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="g-space-1"></div>
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (loading)
                        ?
                        <div className='buttons'>
                            <button className='g-button'>
                                Cancel
                            </button>
                            <button className='g-button'>
                                <ThreeDotsLoader />
                            </button>
                        </div>
                        :
                        <div className='buttons'>
                            <button 
                                className='g-button' 
                                onClick={() => navigate(-1)}>
                                Cancel
                            </button>
                            <button 
                                className={`g-button primary ${
                                    isDirty ? '' : 'disabled'
                                    }`} 
                                onClick={() => saveCollabSettings()}>
                                Save Changes
                            </button>
                        </div>
                    }
                </div>
            }
            
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <AddCollaboratorModal
                gameData={gameData}
                showAddCollabModal={showAddCollabModal}
                setShowAddCollabModal={setShowAddCollabModal}
                orgMembers={orgMembers}
                collabs={collabs}
                addCollaborator={addCollaborator} />                
        </div>
    )
}

export default CollaboratorsOrg